export type Config = {
  env: "production" | "development";
  isProduction: boolean;
  publicUrl: string;
  graphqlUrl: string;
  webUrl: string;
  authServiceUrl: string;
  pollInterval: number;
};

export const config: Config = {
  env: process.env.NODE_ENV as "production" | "development",
  isProduction: process.env.NODE_ENV === "production",
  publicUrl: process.env.PUBLIC_URL,
  graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
  webUrl: process.env.REACT_APP_WEB_URL,
  // HALO auth service base, same value as the HALO app's AUTH_SERVICE_URL
  authServiceUrl: process.env.REACT_APP_AUTH_SERVICE_URL,
  pollInterval: process.env.REACT_APP_SESSION_POLL_INTERVAL
    ? parseInt(process.env.REACT_APP_SESSION_POLL_INTERVAL)
    : 30000,
};
